module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_10-min.4c63a912.jpg";